import { createSlice } from '@reduxjs/toolkit'

import en from 'translations/en.json';
import ru from 'translations/ru.json';

const getOS = () => navigator.userAgent

const LANGUAGES = ['en', 'ru']

const getLanguage = () => {
  const language = `${window?.localStorage?.getItem('vps24-language')}`

  if (LANGUAGES.includes(language)) return language

  return 'en'
}

const TRANSLATION = { en, ru }

const getTranslation = () => {
  const language = `${window?.localStorage?.getItem('vps24-language')}`

  if (LANGUAGES.includes(language)) return TRANSLATION[language]

  return en
}

const getTheme = () => {
  const theme = `${window?.localStorage?.getItem('vps24-theme')}`

  if (['light', 'dark'].includes(theme)) return theme

  const userMedia = window.matchMedia('(prefers-color-scheme: light)')

  if (userMedia.matches) return 'light'

  return 'dark'
}

const initialState = {
  os: getOS(),

  screenHeight: 720,
  screenWidth: 1280,

  language: getLanguage(),
  translation: getTranslation(),

  theme: getTheme(),

  displayLoader: false,
  displayModal: false,
  displayMenu: false,
  displayProfile: false,

  alert: null,
  availablePages: {
    partner: false,
    monitoring: false,
  },
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setScreenHeight: (state, action) => { state.screenHeight = action.payload },
    setScreenWidth: (state, action) => { state.screenWidth = action.payload },

    setLanguage: (state, action) => { state.language = action.payload },
    setTranslation: (state, action) => { state.translation = action.payload },

    setTheme: (state, action) => { state.theme = action.payload },

    setDisplayLoader: (state, action) => { state.displayLoader = action.payload },
    setDisplayModal: (state, action) => { state.displayModal = action.payload },
    setDisplayMenu: (state, action) => { state.displayMenu = action.payload },
    setDisplayProfile: (state, action) => { state.displayProfile = action.payload },

    setAlert: (state, action) => { state.alert = action.payload },
    setAvailablePages: (state, action) => { state.availablePages = action.payload },
  }
})

export const {
  setScreenHeight,
  setScreenWidth,

  setLanguage,
  setTranslation,

  setTheme,

  setDisplayLoader,
  setDisplayModal,
  setDisplayMenu,
  setDisplayProfile,

  setAlert,
  setAvailablePages,
} = appSlice.actions

export default appSlice.reducer
